import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import TreeSelect from 'antd/lib/tree-select';
import ConfigProvider from 'antd/lib/config-provider';
import Input from 'Components/Input';
import { Button } from 'Components/Button';
import validateContactUsV2 from './validateContactUsV2';
import { errorMap } from 'Components/Input/errorMap';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import Textarea from 'Components/Textarea';
import {
  postContactUsV2Form,
  loginWithRefreshToken,
  getCategoriesV2,
  getAuthCategoriesV2,
  getLatestContactUsAgreement,
  isEmailVerifiedInSixMonths,
  emailVerify,
  getCaptchaHash,
  captchaVerify
} from 'Store/actions';
import Modal from 'Components/Modal';
import Message from 'Components/Modal/Message';
import { getUrlParameter } from 'Utils/getUrlParameter';
import { isWebviewRenderType } from 'Utils/webviewMode';
import EnvironmentManager from 'Utils/environmentManager';
import LottieLoader from 'Components/LottieLoader';
import { Checkbox } from 'Components/Form';
import Contract from 'Components/Modal/Contract';
import Icon from 'Components/Icon';
import ToastTemplate from 'Components/ToastTemplate';
import { toast } from 'react-toastify';
// import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
// import ProjectConfig from 'ProjectConfig';
import { toggleCaptchaBadge } from 'Utils/reCaptcha';

const formFields = {
  firstName: '',
  lastName: '',
  email: '',
  categoryId: '',
  description: '',
};

class ContactUsV2 extends Component {
  static propTypes = {
    categories: PropTypes.object,
    getCategoriesV2: PropTypes.func,
    getAuthCategoriesV2: PropTypes.func,
    postContactUsV2Form: PropTypes.func,
    auth: PropTypes.object,
    loginWithRefreshToken: PropTypes.func,
    postData: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    isEmailVerifiedInSixMonths: PropTypes.func,
    emailVerify: PropTypes.func,
    // googleReCaptchaProps: PropTypes.object,
    getCaptchaHash: PropTypes.func,
    captchaVerify: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.kvkkData = {
      version: '',
      content: '',
    };

    this.state = {
      ...formFields,
      validationErrors: {
        ...formFields
      },
      activeModal: null,
      modalContent: null,
      modalTitle: null,
      modalButton: null,
      modalIcon: null,
      modalType: null,
      isWebview: false,
      treeSelectActiveClass: '',
      treeSelectPlaceholder: '',
      treeSelectName: 'Konu',
      checkboxKVKK: false,
      captchaError: false,
      emailVerified: null,
      verificationEmailSent: false,
      showDescriptionArea: true,
      captchaHash: '',
      stringValue: '',
      errorValue: '',
    };
  }

  async componentDidMount () {
    toggleCaptchaBadge(true);

    const { isAuthenticated } = this.props.auth;
    this.setState({
      isWebview: isWebviewRenderType(),
    });

    const refreshToken = getUrlParameter('refreshToken');
    if (refreshToken) {
      await this.props.loginWithRefreshToken(refreshToken);
    }

    if (isAuthenticated) {
      const { name, surName, email } = this.props.auth.data;

      if (name && surName && email) {
        this.fillInputs();
      }
      if (this.props.location?.state?.isRating) {
        this.props.getCategoriesV2(!!this.props.location?.state?.isRating).then(res=>{
          this.setState({
            categoryId: this.props.location?.state?.isRating ? res.find(item=>item.name === 'Geri Bildirim')?.id : ''
          });
        });
      } else {
        this.props.getAuthCategoriesV2();
      }
    } else {
      this.props.getCategoriesV2(false);
    }
    this.checkEmailIsVerified();

    getLatestContactUsAgreement().then(res => {
      const { version, content } = res?.data || {};
      this.kvkkData = {
        version,
        content,
      };
    });
  }

  componentWillUnmount () {
    toggleCaptchaBadge(false);
  }

  componentDidUpdate (prevProps) {
    toggleCaptchaBadge(true);
    const { isAuthenticated: prevIsAuthenticated } = prevProps.auth;
    const { isAuthenticated } = this.props.auth;

    if (isAuthenticated && prevIsAuthenticated !== isAuthenticated) {
      const { name, surName, email } = this.props.auth.data;

      if (name && surName && email) {
        this.fillInputs();
      }
      this.props.getAuthCategoriesV2();
      this.checkEmailIsVerified();
    }

    if (!isEqual(prevProps.postData, this.props.postData)) {
      this.modalTypeHandler();
    }
  }

  checkEmailIsVerified = () => {
    const { isAuthenticated } = this.props.auth;
    if (isAuthenticated) {
      const { email } = this.props.auth.data;
      this.props.isEmailVerifiedInSixMonths(email).then(res => {
        if (res.isEmailVerified) {
          this.setState({ emailVerified: 1 });
        } else {
          this.setState({ emailVerified: 0 });
        }
      });
    }
  };

  fillInputs () {
    const { name, surName, email } = this.props.auth.data;

    this.setState({
      firstName: name,
      lastName: surName,
      email: email.trim(),
    });
  }

  clearFormInputs = () => {
    if (this.props.auth.isAuthenticated) {
      this.setState({
        categoryId: '',
        description: '',
        checkboxKVKK: false,
      });
    } else {
      this.setState({
        firstName: '',
        lastName: '',
        email: '',
        categoryId: '',
        description: '',
        checkboxKVKK: false,
      });
    }
  };


  modalTypeHandler = () => {
    const { postData } = this.props;
    const { isAuthenticated } = this.props.auth;

    let modalButtonConfig
      = this.state.isWebview
        ? {
          primaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'button_okay' }) || 'Tamam',
            onClick: this.closeModal,
          },
        } : (
          {
            primaryButton: {
              label: postData?.error?.code === 4011 ? 'GİRİŞ YAP' : (EnvironmentManager.getMessageText({ key: 'button_okay' }) || 'Tamam'),
              onClick: postData?.error?.code === 4011 ? () => this.props.history.push('/giris-yap') : this.closeModal,
            }
          }
        );

    let title = 'Mesajınız bize ulaştı';
    if (isAuthenticated && postData.error?.domain === 'bip-ticket-api' && postData.error?.code === 4017) {
      modalButtonConfig = {
        primaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_instant_spin' }) || 'Hemen Çevir',
          onClick: () => {
            this.closeModal,
            this.props.history.push('/kampanyalar');
          }
        },
        secondaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_go_bulletin' }) || 'Bültene Git',
          onClick: () => {
            this.closeModal,
            this.props.history.push('/canli-iddaa');
          }
        }
      };
      title = EnvironmentManager.getMessageText({ key: 'title_spin_wheel_of_fortune_for_gifts' }) || "Sürpriz Hediyeler Kazanma Fırsatınız Şans Çarkı'nda!";

    } else if (isAuthenticated && (postData.error?.domain === 'bip-ticket-api' || postData.error?.domain === 'ticket-api') && (postData.error?.code === 4015 || postData.error?.code === 4060)) {
      modalButtonConfig = {
        primaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_go_bulletin' }) || 'BÜLTENE GİT',
          onClick: () => {
            this.closeModal,
            this.props.history.push('/canli-iddaa');
          }
        }
      };
      title = postData.error?.code === 4015 ? EnvironmentManager.getMessageText({ key: 'title_bos_request_delivered' }) || 'Talebiniz Bize Ulaştı!' : EnvironmentManager.getMessageText({ key: 'title_bos_request_on_evaluation_phase' }) || 'Önceki Talebinizin Değerlendirmesine Devam Ediyoruz!';
    } else if (isAuthenticated && postData.error?.domain === 'bip-ticket-api' && postData.error?.code === 4018) {
      modalButtonConfig = {
        primaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_go_account_activities' }) || 'Hesap Hareketlerim',
          onClick: () => {
            this.closeModal,
            this.props.history.push('/hesabim/hesap-hareketlerim');
          }
        },
        secondaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_go_bulletin' }) || 'Bültene Git',
          onClick: () => {
            this.closeModal,
            this.props.history.push('/canli-iddaa');
          }
        }
      };
      title = EnvironmentManager.getMessageText({ key: 'title_bos_request_completed' }) || 'Hediyeniz Hesabınıza Yüklendi!';
    } else if (isAuthenticated && postData.error?.domain === 'bip-ticket-api' && postData.error?.code === 4009 ) {
      title = EnvironmentManager.getMessageText({ key: 'title_bos_message_not_received' }) || 'Mesajınız Gönderilemedi';
      modalButtonConfig = {
        primaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_okay' }) || 'Tamam',
          onClick: this.closeModal,
        }
      };
      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <Message type="none">
            { EnvironmentManager.getMessageText({ key: 'description_bos_login_message_not_received' }) || 'Talebini iletmek için e-postanı doğrulaman gerekmektedir. "Kişisel Bilgilerim" bölümünden e-posta adresini doğrulayabilirsin.' }
          </Message>
        ),
        modalTitle: title,
        modalIcon: 'svgGenaralWarning',
        modalType: 'error',
      });
    }

    if (postData.error?.message && [4060].includes(postData.error?.code) ) {
      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <Message type="none">
            { EnvironmentManager.getMessageText({ key: 'ticket-api4060' }) }
          </Message>
        ),
        modalTitle: title,
        modalIcon: 'svgLike',
        modalType: 'success',
      });
      this.clearFormInputs();
    }

    if (postData.error?.message && [4015, 4017, 4018].includes(postData.error?.code) ) {
      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <Message type="none">
            { EnvironmentManager.getMessageText({ key: 'description_bos_message_received' }) }
          </Message>
        ),
        modalTitle: title,
        modalIcon: 'svgLike',
        modalType: 'success',
      });
      this.clearFormInputs();
    }
    if (postData.error?.message && [4020].includes(postData.error?.code)) {
      title = EnvironmentManager.getMessageText({ key: 'title_bos_message_not_received' }) || 'Mesajınız Gönderilemedi';
      modalButtonConfig = {
        primaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_verify' }) || 'Doğrula',
          className: 'btn btn--primary btn-verify',
          disabled: true,
          onClick: () => {
            this.closeModal();
            this.verifyEmail();
          }
        }
      };

      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <div>
            <Message type="none">
              { EnvironmentManager.getMessageText({ key: 'description_bos_logout_message_not_received' }) }

              <div className='contact-us__captcha-main'>
                <div id='captcha'/>
                <div id="captcha-input" className="inline">
                  <Input
                    name="Güvenlik Kodu"
                    id="captchaValue"
                    onChange={ this.onChange }
                    clearInput={ this.clearInput }
                    validateOnBlur
                    onBlur={ this.onBlur }
                    errorMessage={ this.getInputError('captchaValue')  }
                  />
                </div>
              </div>

            </Message>
          </div>
        ),
        modalTitle: title,
        modalIcon: 'svgGenaralWarning',
        modalType: 'error',
      });
    }

    if (postData.error?.message && [4005].includes(postData.error?.code)) {
      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <Message type="none">
            {  EnvironmentManager.getMessageText({ key: 'ticket-api4005' }) }
          </Message>
        ),
        modalTitle: EnvironmentManager.getMessageText({ key: 'title_bos_message_not_received' }),
        modalIcon: 'svgGenaralWarning',
        modalType: 'error',
      });
    }

    if (postData.error?.message && ![4005, 4009, 4015, 4017, 4018, 4060, 4020].includes(postData.error?.code)) {
      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <Message type="none">
            { EnvironmentManager.getMessageText({
              key: 'bip-ticket-api4003'
            }) }
          </Message>
        ),
        modalTitle: EnvironmentManager.getMessageText({ key: 'title_bos_message_not_received' }),
        modalIcon: 'svgGenaralWarning',
        modalType: 'error',
      });
      if (postData.error.code === 4001) {
        this.setState({
          captchaError: true,
        });
      }
    }


    if (postData.data?.message ) {
      this.setState({
        activeModal: 'messageModal',
        modalButton: modalButtonConfig,
        modalContent: (
          <Message type="none">
            Talebiniz işleme alındı. Sistemde kayıtlı e-posta adresinize
            bilgilendirme yapılacaktır.
          </Message>
        ),
        modalTitle: 'Mesajınız bize ulaştı',
        modalIcon: 'svgLike',
        modalType: 'success',
      });
    }
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
      modalButton: null,
      modalContent: null,
      modalTitle: null,
      modalIcon: null,
      modalType: null,
    });
  };

  verifyEmail = () => {
    if (this.props.auth.isAuthenticated) {
      this.props
        .emailVerify()
        .then(res => {
          if (res) {
            this.setState({ emailVerified: null });
            this.setState({ verificationEmailSent: true });
          }
        })
        .catch(error => {
          toast(
            <ToastTemplate type="error" icon="svgInfoWhite">
              { error.message }
            </ToastTemplate>
          );
        });
    } else {
      this.props
        .captchaVerify(this.state.captchaValue, this.state.captchaHash, this.state.email)
        .then(res => {
          if (res?.status === 200) {
            toast(
              <ToastTemplate type="success" >
                { EnvironmentManager.getMessageText({
                  key: 'success_approval_code_message_recived'
                }) }
              </ToastTemplate>
            );
            this.closeModal();
          } else {
            toast(
              <ToastTemplate type="error" icon="svgInfoWhite">
                { res?.data?.message }
              </ToastTemplate>
            );
            this.closeModal();
          }

        })
      ;

    }
  };

  onChange = e => {
    let { id, value, tagName, options, selectedIndex } = e.target;
    const regexWhiteList = /[^a-zA-Z0-9ĞÜŞİÖÇğüşıöç.,:;"'@?&#%=_*()/\-\n ]/gi;
    if (id === 'captchaValue') {
      const button = document.getElementsByClassName('btn btn--primary btn-verify')[0];
      button.onclick = ()=> {
        this.verifyEmail();
      };
      if (e.target.value.length === 5) {
        button.disabled = false;
        button.classList.remove('btn--disabled');
      } else {
        button.disabled = true;
        button.classList.add('btn--disabled');
      }

    }


    this.setState({
      [id]: id === 'email' ? value : value.replace(regexWhiteList, ''),
      validationErrors: {
        ...this.state.validationErrors,
        [id]: '',
      },
    });

    if (tagName === 'SELECT') {
      const selectedText = options[selectedIndex].text;

      this.setState({
        [id + 'Text']: selectedText,
      });
    }
  };

  onBlur = e => {
    let { id, value } = e.target;
    const validator = validateContactUsV2({
      ...this.state,
      [id]: value,
    });

    if (!validator.isValid) {
      this.setState({
        validationErrors: {
          ...this.state.validationErrors,
          [id]: validator.errors[id],
        },
      });
    }
  };

  getChannel = () => {
    const { location } = this.props;
    const queryParams = queryString.parse(location.search);
    const channel = queryParams.channel || 'MOBILE_WEB';

    return channel;
  };


  onSubmit = async e => {
    e.preventDefault();

    let contactUsForm;
    // const isReCaptchaEnabled = ProjectConfig.reCaptchaEnabled;
    const { auth } = this.props;

    /*
    // reCAPTCHA v3 (temporarily disabled)
    if (isReCaptchaEnabled) {
      const { executeRecaptcha } = this.props.googleReCaptchaProps;
      const token = await executeRecaptcha('contactUs');
      contactUsForm = { ...contactUsForm, captcha: token };
    }
    */

    const validator = validateContactUsV2(this.state, !this.state.showDescriptionArea);
    if (validator.isValid) {
      contactUsForm = {
        ...contactUsForm,
        channel: this.getChannel(),
        description: this.state.description,
        categoryId: this.state.categoryId,
        kvkkVersion: this.kvkkData.version,
      };

      if (!auth.isAuthenticated) {
        contactUsForm = {
          ...contactUsForm,
          email: this.state.email,
          name: this.state.firstName,
          surname: this.state.lastName,
        };
      }

      if (!this.state.showDescriptionArea) {
        contactUsForm.description = '';
      }

      this.props.postContactUsV2Form(contactUsForm).then(res=>{
        if (res?.code === 4020) {
          this.props.getCaptchaHash().then(item=>{
            this.setState({ captchaHash: item?.hash });
            const image = new Image();
            image.src = `data:image/png;base64,${item.base64Captcha}`;
            const node = document.createElement('img');
            node.setAttribute('src', image.src);
            node.setAttribute('class', 'contact-us__captcha-image');
            document.getElementById('captcha').appendChild(node);
          });
        }
      });
    }
  };

  getInputError = fieldName => {
    const { validationErrors, fieldMessage } = this.state;
    return validationErrors[fieldName] === 'api'
      ? fieldMessage
      : errorMap[validationErrors[fieldName]];
  };

  render () {
    const {
      firstName,
      lastName,
      email,
      categoryId,
      description,
      isWebview,
      checkboxKVKK,
      emailVerified,
      verificationEmailSent,
      captchaError,
    } = this.state;
    const isButtonDisabled = !(
      firstName
      && lastName
      && email
      && categoryId
      && checkboxKVKK
      && !captchaError
    );

    const { isAuthenticated } = this.props.auth;

    const descriptionMaxLength = 1500;

    const renderEmptyState = () => (
      <div style={ { textAlign: 'center' } }>
        <p>Kategori bulunamadı.</p>
      </div>
    );
    return (
      <>
        { !isWebview && (
          <HeaderSimplePage
            color="green"
            title="Bize Yazın"
            callCustomerService
            icon={ { name: 'svgCallCustomerService' } }
          />
        ) }

        <div className="page page--contact-us">
          <div className="contact-us__container">
            <form className="form" onSubmit={ this.onSubmit }>
              <div className="form__row">
                <div className="form__col form__col--50">
                  <Input
                    name="Ad"
                    id="firstName"
                    value={ firstName }
                    onChange={ this.onChange }
                    clearInput={ this.clearInput }
                    validateOnBlur
                    onBlur={ this.onBlur }
                    errorMessage={ this.getInputError('firstName') }
                    disabled={ isAuthenticated }
                  />
                </div>

                <div className="form__col form__col--50">
                  <Input
                    name="Soyad"
                    id="lastName"
                    value={ lastName }
                    onChange={ this.onChange }
                    clearInput={ this.clearInput }
                    validateOnBlur
                    onBlur={ this.onBlur }
                    errorMessage={ this.getInputError('lastName') }
                    disabled={ isAuthenticated }
                  />
                </div>
              </div>

              <div className="form__row">
                <div className={ `input ${this.state.treeSelectActiveClass}` } style={ this.props.location?.state?.isRating ? { opacity: .5, 'pointer-events': 'none' }  : null }>
                  { !this.props.location?.state?.isRating && <label className="input__label">
                    { this.state.treeSelectName }
                  </label> }
                  <ConfigProvider renderEmpty={ renderEmptyState }>
                    <TreeSelect
                      placeholder={ this.state.treeSelectPlaceholder }
                      className="input__input"
                      value={ categoryId }
                      showSearch
                      filterOption={ (inputValue, option) =>
                        option.title
                          .toLocaleLowerCase('tr-TR')
                          .indexOf(inputValue.toLocaleLowerCase('tr-TR')) > -1
                      }
                      allowClear
                      dropdownClassName="contact-us-tree-dropdown"
                      dropdownStyle={ { maxHeight: 400, overflow: 'auto', zIndex: '1' } }
                      treeData={ updateCategoryListForTreeSelect(filterCategoryList(
                        this.props.categories.data,
                        isAuthenticated,
                      )) }
                      treeNodeFilterProp="title"
                      onSelect={ (value, node) => {
                        this.setState({ showDescriptionArea: node.descriptionRequired });
                        if (node.isEmailVerify) {
                          this.checkEmailIsVerified();
                        } else {
                          this.setState({ emailVerified: false });
                        }
                      } }
                      onFocus={ () => {
                        this.setState({
                          treeSelectActiveClass: 'input--active',
                          treeSelectPlaceholder: 'Seçin ya da arayın',
                          treeSelectName: 'Konu',
                        });
                      } }
                      onChange={ value => {
                        if (value) {
                          this.setState({
                            categoryId: value,
                            treeSelectActiveClass: 'input--active',
                            treeSelectName: 'Konu',
                            treeSelectPlaceholder: 'Seçin ya da arayın',
                          });
                        } else {
                          this.setState({
                            treeSelectActiveClass: 'input--active input--error',
                            treeSelectName: 'Bu alan zorunludur.',
                            treeSelectPlaceholder: 'Konu',
                          });
                        }
                        this.setState({
                          categoryId: value,
                        });
                      } }
                      onBlur={ () => {
                        if (!this.state.categoryId) {
                          this.setState({
                            treeSelectActiveClass: 'input--active input--error',
                            treeSelectName: 'Bu alan zorunludur.',
                            treeSelectPlaceholder: 'Konu',
                          });
                        } else {
                          this.setState({
                            treeSelectActiveClass: 'input--active',
                            treeSelectName: 'Konu',
                            treeSelectPlaceholder: 'Seçin ya da arayın',
                          });
                        }
                      } }
                    />
                  </ConfigProvider>
                </div>
              </div>

              <div className="form__row">
                <Input
                  name="E-Posta Adresi"
                  id="email"
                  type="email"
                  value={ email }
                  onChange={ this.onChange }
                  clearInput={ this.clearInput }
                  onBlur={ this.onBlur }
                  validateOnBlur
                  errorMessage={ this.getInputError('email') }
                  disabled={ isAuthenticated }
                  append={
                    emailVerified === 1 && <Icon iconName="svgCheckGreen" />
                  }
                />
                { emailVerified === 0 && !verificationEmailSent && (
                  <span className="verify-btn" onClick={ this.verifyEmail }>
                    { EnvironmentManager.getMessageText({ key: 'button_verify' }) }
                  </span>
                ) }
                { verificationEmailSent && (
                  <span className="email-status">
                    <Icon iconName="svgInfoGrey" className="info-icon" />
                    Doğrulama epostası gönderildi.
                  </span>
                ) }
              </div>

              { this.state.showDescriptionArea
                && <>
              <div className="form__row padding-bottom-0">
                <Textarea
                  id="description"
                  value={ description }
                  validateOnBlur
                  className="input--textarea"
                  placeholder="Bilyoner ile ilgili her türlü soru, öneri, şikayet ya da memnuniyetini bize ilet."
                  onBlur={ this.onBlur }
                  onChange={ this.onChange }
                  required
                  maxLength={ descriptionMaxLength }
                />
              </div>

              <div className="text-small">
                { `Kalan karakter: ${descriptionMaxLength - description.length}` }
              </div>
                </>
              }

              <div className="form__row form__row--checkbox margin-top-10">
                <div className="form__row--checkbox__input">
                  <Checkbox
                    className="switch"
                    checked={ checkboxKVKK }
                    onChange={ () => {
                      this.setState({
                        checkboxKVKK: !checkboxKVKK,
                      });
                    } }
                  />
                </div>

                <div className="form__row--checkbox__label">
                  <label>
                    Bize Yazın sekmesi aracılığıyla işlenen kişisel verilerim
                    hakkında hazırlanmış&nbsp;
                    <span
                      className="link-green"
                      onClick={ () => {
                        this.setState({
                          activeModal: 'kvkkModal',
                          modalContent: (
                            <Contract>{ this.kvkkData.content }</Contract>
                          ),
                          modalTitle: 'KVKK Bize Yazın Aydınlatma Metni',
                        });
                      } }
                    >
                      Aydınlatma Metni
                    </span>
                    ’ni okudum, anladım.
                  </label>
                </div>
              </div>

              { isAuthenticated && !email && (
                <div className="text-error margin-top-10">
                  E-posta adresiniz sistemimizde kayıtlı değildir. Mesajınızı
                  bize iletebilmeniz için e-posta adresinizi uygulamalarımız
                  üzerinde yer alan Kişisel Bilgilerim bölümünden ya da 0850 272
                  0 272 numaralı Müşteri Hizmetlerimizi arayarak
                  güncelleyebilirsiniz.
                </div>
              ) }

              <div className="form_row margin-top-20">
                <Button
                  title={ 'GÖNDER' }
                  disabled={ isButtonDisabled }
                  className="btn btn--primary btn--block"
                  type="submit"
                >
                  GÖNDER
                </Button>
              </div>
            </form>
          </div>
          { this.props.postData.isLoading && (
            <Modal
              title="Mesajın gönderiliyor..."
              showClose={ false }
              overlayClick={ false }
            >
              <LottieLoader type="loading" loop={ true } autoplay width="38px" />
            </Modal>
          ) }
          { this.state.activeModal && (
            <Modal
              type={ this.state.modalType }
              iconName={ this.state.modalIcon }
              title={ this.state.modalTitle }
              onClose={ this.closeModal }
              buttonArea={ this.state.modalButton }
              position={ this.state.activeModal === 'kvkkModal' && { web: 'center' } }
              className={ this.state.activeModal === 'kvkkModal' ? 'contact-us__kvkk-modal' : undefined }
            >
              { this.state.modalContent }
            </Modal>
          ) }
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.contactUs.categories,
  postData: state.contactUs.postContactUsForm,
  auth: state.auth,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getCategoriesV2,
    getAuthCategoriesV2,
    postContactUsV2Form,
    loginWithRefreshToken,
    isEmailVerifiedInSixMonths,
    emailVerify,
    getCaptchaHash,
    captchaVerify
  })
)(ContactUsV2);
// )(withGoogleReCaptcha(ContactUsV2));


const filterCategoryList = (data, isAuthenticated) => {
  if (!isAuthenticated) {
    return data?.filter(item => {
      return !item.isNeedLogin;
    });
  }
  return data;
};

const updateCategoryListForTreeSelect = data => {
  return data.map(item => {
    let newItem = {
      id: item.id,
      title: item.name,
      value: item.id,
      isEmailVerify: item.isEmailVerify,
      children: item.subCategories ? [...item.subCategories] : [],
      descriptionRequired: item.descriptionRequired
    };

    if (newItem.children && newItem.children.length > 0) {
      newItem.disabled = true;
      newItem.children = updateCategoryListForTreeSelect(newItem.children);
    }

    return newItem;
  });
};
